import { render, staticRenderFns } from "./ZPrevSvg.vue?vue&type=template&id=2688ec14&scoped=true"
import script from "./ZPrevSvg.vue?vue&type=script&lang=js"
export * from "./ZPrevSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688ec14",
  null
  
)

export default component.exports